<template>
<div id="print_station">

    <h1>עמדת הדפסה - לוגיסטיקה</h1>

    <div class="station_box">
        <div class="station_row">
            <span>מזהה עמדה:</span>
            <b v-text="station_key"></b>
        </div>
        <div class="station_row">
            <span>מדפיס עבור:</span>
            <select v-model="register" @change="save_register">
                <option value="001">קופה 1</option>
                <option value="002">קופה 2</option>
                <option value="">כל הקופות</option>
            </select>
        </div>
        <div class="station_row" v-if="register != ''">
            <label>
                <input type="checkbox" v-model="include_unassigned" @change="save_register" />
                להדפיס כאן גם הזמנות ששולמו שלא דרך מסוף קופה
            </label>
        </div>
        <div class="station_row">
            <span>סטטוס:</span>
            <b :class="(polling ? 'ok' : 'off')" v-text="(polling ? 'מחובר - ממתין להזמנות' : 'מנותק')"></b>
        </div>
        <div class="station_row">
            <span>בדיקה אחרונה:</span>
            <b v-text="last_check"></b>
        </div>
        <div class="station_row">
            <span>עבודה ברקע:</span>
            <b :class="(keep_alive ? 'ok' : 'off')" v-text="(keep_alive ? 'פעילה - מדפיס גם כשהחלון ממוזער' : 'לא פעילה - לחץ על הכפתור למטה')"></b>
        </div>
        <div class="station_row" v-if="error != ''">
            <span>שגיאה:</span>
            <b class="off" v-text="error"></b>
        </div>

        <button class="station_btn" @click="toggle" v-text="(polling ? 'עצור' : 'הפעל')"></button>
        <button class="station_btn" @click="check" :disabled="busy">בדוק עכשיו</button>
        <button class="station_btn" v-if="!keep_alive" @click="start_keep_alive">הפעל עבודה ברקע</button>
    </div>

    <div class="station_box">
        <div class="title_small">הזמנות שהודפסו במחשב הזה</div>
        <div v-if="printed.length == 0">עדיין לא הודפסו הזמנות</div>
        <table v-else>
            <tbody>
                <tr v-for="row in printed" :key="row.id">
                    <td v-text="'#' + row.id"></td>
                    <td v-text="row.name"></td>
                    <td v-text="row.register"></td>
                    <td v-text="row.time"></td>
                </tr>
            </tbody>
        </table>
    </div>

    <div id="station_frames"></div>

</div>
</template>

<script>
export default {
    name: 'station',
    data(){
        return {
            station_key: '',
            register: '001',
            include_unassigned: false,
            polling: false,
            busy: false,
            last_check: '-',
            error: '',
            printed: [],
            timer: null,
            keep_alive: false,
            audio_ctx: null,
        }
    },
    mounted(){
        this.$emit('loaded');

        // מזהה קבוע למחשב הזה - נשמר בדפדפן, כך שרק המחשב שחובר מדפיס
        this.station_key = localStorage.getItem('print_station_key');
        if (this.isNull(this.station_key))
        {
            this.station_key = 'st_' + Math.random().toString(36).substr(2, 10) + Date.now().toString(36);
            localStorage.setItem('print_station_key', this.station_key);
        }

        // הקופה שהמחשב הזה מדפיס עבורה - נבחרת פעם אחת ונשמרת בדפדפן
        let saved_register = localStorage.getItem('print_station_register');
        if (saved_register !== null) this.register = saved_register;

        if (!this.isNull(this.$route.query.register)) this.register = String(this.$route.query.register);

        this.include_unassigned = (localStorage.getItem('print_station_unassigned') == '1');

        /*
         * Chrome מאט טיימרים בחלון ממוזער לפעימה בערך בדקה. דף שמשמיע
         * צליל נחשב פעיל וממשיך לרוץ בקצב מלא, ולכן מנגנים צליל אילם.
         * ההפעלה דורשת לחיצה של המשתמש, לכן מנסים גם בלחיצה הראשונה בדף.
         */
        this.start_keep_alive();
        document.addEventListener('click', this.start_keep_alive);
        document.addEventListener('visibilitychange', this.on_visible);

        this.start();
    },
    beforeDestroy(){
        this.stop();
        document.removeEventListener('click', this.start_keep_alive);
        document.removeEventListener('visibilitychange', this.on_visible);
        if (this.audio_ctx) this.audio_ctx.close();
    },
    methods: {
        start(){
            this.polling = true;
            this.timer = setInterval(this.check, 15000);
            this.check();
        },
        stop(){
            this.polling = false;
            if (this.timer) clearInterval(this.timer);
            this.timer = null;
        },
        toggle(){
            if (this.polling) this.stop();
            else this.start();
        },
        start_keep_alive(){
            try
            {
                if (this.audio_ctx)
                {
                    if (this.audio_ctx.state == 'suspended') this.audio_ctx.resume();
                    this.keep_alive = (this.audio_ctx.state == 'running');
                    return;
                }

                let Ctx = (window.AudioContext || window.webkitAudioContext);
                if (!Ctx) return;

                let ctx = new Ctx();
                let osc = ctx.createOscillator();
                let gain = ctx.createGain();

                // כמעט אילם, אבל לא אפס - אחרת Chrome לא מחשיב את הדף כמשמיע
                gain.gain.value = 0.0015;
                osc.frequency.value = 60;
                osc.connect(gain);
                gain.connect(ctx.destination);
                osc.start();

                this.audio_ctx = ctx;
                this.keep_alive = (ctx.state == 'running');
            }
            catch (e)
            {
                this.keep_alive = false;
            }
        },
        on_visible(){
            // חזרה לחלון - בדיקה מיידית במקום להמתין לסבב הבא
            if (!document.hidden && this.polling) this.check();
        },
        save_register(){
            localStorage.setItem('print_station_register', this.register);
            localStorage.setItem('print_station_unassigned', (this.include_unassigned ? '1' : '0'));

            this.check();
        },
        check(){
            if (this.busy) return;
            this.busy = true;

            let station_name = (this.isNull(this.$route.query.name) ? '' : this.$route.query.name);

            this.net_api({ action: 'print_station_queue', data: {
                station: this.station_key,
                name: station_name,
                register: this.register,
                include_unassigned: (this.include_unassigned ? '1' : '0')
            } }, (res) => {
                this.busy = false;
                this.last_check = new Date().toLocaleTimeString('he-IL');

                let data = (res && res.data ? res.data : false);

                if (!data || data.error)
                {
                    this.error = (data && data.error ? data.error : 'שגיאת תקשורת');
                    return;
                }

                this.error = '';

                if (data.orders && data.orders.length > 0) this.print_orders(data.orders);
            }, () => {
                this.busy = false;
                this.error = 'שגיאת תקשורת';
            });
        },
        print_orders(orders){
            this.busy = true;

            let i = 0;

            let next = () => {
                if (i >= orders.length)
                {
                    this.busy = false;
                    return;
                }

                let order = orders[i];
                i++;

                /*
                 * מסמנים כמודפס לפני ההדפסה - עדיף הזמנה שלא יצאה (ואפשר
                 * להדפיס ידנית מהאדמין) על פני הדפסות כפולות בלולאה.
                 */
                this.net_api({ action: 'print_station_ack', data: { station: this.station_key, order_id: order.id } }, (res) => {

                    // חלון עמדה אחר כבר תפס את ההזמנה - לא מדפיסים אותה שוב
                    if (!res || !res.data || !res.data.claimed)
                    {
                        next();
                        return;
                    }

                    this.printed.unshift({
                        id: order.id,
                        name: order.name,
                        register: (order.shop_number == '002' ? 'קופה 2' : (order.shop_number == '001' ? 'קופה 1' : 'ללא קופה')),
                        time: new Date().toLocaleTimeString('he-IL')
                    });
                    this.printed = this.printed.slice(0, 30);

                    // ההזמנה המלאה, עם מחירים - עותק אחד
                    this.print_doc('/print/' + order.id + '?station=1', next);
                });
            };

            next();
        },
        print_doc(url, done){
            let holder = document.getElementById('station_frames');

            let frame = document.createElement('iframe');
            frame.style.position = 'fixed';
            frame.style.left = '-10000px';
            frame.style.width = '900px';
            frame.style.height = '1200px';
            frame.src = url;

            holder.appendChild(frame);

            // דף ההדפסה קורא ל-window.print() בעצמו אחרי שהנתונים נטענים
            setTimeout(() => {
                if (frame.parentNode) frame.parentNode.removeChild(frame);
                done();
            }, 12000);
        },
    }
}
</script>

<style lang="scss">
#print_station {
    padding: 20px;
    max-width: 700px;
    margin: 0 auto;

    h1 { font-size: 26px; margin-bottom: 20px; }

    .station_box {
        border: 1px solid #ddd;
        border-radius: 8px;
        padding: 15px;
        margin-bottom: 20px;
        background: #fff;
    }

    .station_row {
        display: flex;
        gap: 8px;
        padding: 4px 0;

        span { color: #777; }
        b.ok { color: #1a9c3e; }
        b.off { color: #c22; }
    }

    .station_btn {
        margin: 10px 5px 0 0;
        padding: 8px 18px;
        font-size: 16px;
        cursor: pointer;
    }

    table { width: 100%; }
    td { padding: 3px 6px; border-bottom: 1px solid #eee; }
}

@media print {
    #print_station { display: none; }
}
</style>
